module.exports = __webpack_public_path__ + "img/56400.9e9f77d5.jpg";